import moment from 'moment-timezone';

export function abbrDateYear(date) {
    return date.format('MMM D, YYYY');
}

export function fullDateYear(date) {
    return date.format('MMMM D, YYYY');
}

export function abbrDateNoYear(date) {
    return date.format('MMM D');
}

export function getWeekRange(date, zone = 'America/Los_Angeles') {
    let days = getDaysOfWeek(date, zone);
    const from = days[0];
    const to = days[6]
        .set('hours', 23)
        .set('minutes', 59)
        .set('seconds', 59);

    return { from, to };
}

export function getDaysOfWeek(current, zone = 'America/Los_Angeles') {
    if (!current) throw new Error('Date must be provided.');

    const today = moment.tz(current, zone);
    const monday = today.clone().startOf('isoWeek');

    const days = [monday];
    for (let i = 1; i < 7; i++) {
        days.push(monday.clone().add(i, 'days'));
    }

    return days;
}

export function getLastPeriodEnd(zone = 'Etc/UTC') {
    const currentWeek = getWeekRange(moment.tz(zone), zone);
    return currentWeek.to.clone().add(-7, 'days');
}

export function isSameWeek(selected, compared, zone = 'America/Los_Angeles') {
    if ((selected && !compared) || (compared && !selected)) {
        return false;
    }
    if (!selected && !compared) {
        return true;
    }
    let range1 = getWeekRange(selected, zone);
    let range2 = getWeekRange(compared, zone);

    return isSameDay(range1.from, range2.from) && isSameDay(range1.to, range2.to);
}

export function isCurrentWeek(current, zone = 'America/Los_Angeles') {
    let range = getWeekRange(moment.tz(zone), zone);
    return current >= range.from && current <= range.to;
}

export function isSameDay(selected, compared) {
    if (!selected && !compared) return true;
    return moment(selected).isSame(moment(compared), 'day');
}

/**
 * Convert minutes to a time in format hh:mm
 * Returned value is in range 00  to 24 hrs
 * @param {Number} minutes
 */
export function timeFromMinutes(minutes, upTo24 = true) {
    let format = n => (n < 10 ? '0' : '') + n;

    let h = (minutes / 60) | 0;
    if (upTo24) {
        h = h % 24;
    }

    let m = Math.round(minutes % 60);

    return `${format(h)}:${format(m)}`;
}

export function dateToFloatingString(date, format = 'MMMM DD, YYYY') {
    if (!date) return '';
    return moment.utc(date).format(format);
}

export function fixDate(date) {
    return typeof date === 'string' && date.includes('-') ? new Date(date.split('-').join('/')) : date;
}

export const maxTimeSpan = 8640000000000000;

export function jobHasStarted(job) {
    if (job.status !== 'active' && job.status !== 'inactive') return false;

    const startDateMoment = moment.tz(job.start_date, job.work_timezone);
    return startDateMoment.isBefore();
}

export function jobActiveAndStarted(job) {
    return job.status === 'active' && jobHasStarted(job);
}



// WEBPACK FOOTER //
// ./src/utilities/dateTime.jsx